export default function deg2rad(deg) {
    return deg * (Math.PI/180)
}